var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayslip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_05ef3c109c3072eb1cc6dfed9bac3aae1a6ea45a0cc0e63f6665d011dac18d68",
    x1: 41.49,
    y1: 44.398,
    x2: 69.219,
    y2: 44.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M2.894 13.756h79.211v38.488H2.894z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M26.28 24.776s-.494-2.859-2.859-2.859-3 2.859-3 2.859l6.142 4.657M20.703 29.433s.494 2.859 2.859 2.859 3-2.859 3-2.859M23.492 19.481v2.436M23.492 32.292v2.436M74.302 16.059v2.385M74.302 21.253v2.385M74.302 26.446v2.385M74.302 31.64v2.385M74.302 36.833v2.385M74.302 42.027v2.385M74.302 47.22v2.385M11.234 16.059v2.385M11.234 21.253v2.385M11.234 26.446v2.385M11.234 31.64v2.385M11.234 36.833v2.385M11.234 42.027v2.385M11.234 47.22v2.385"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M49.818 35.669h18.776v3.921H49.818z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_05ef3c109c3072eb1cc6dfed9bac3aae1a6ea45a0cc0e63f6665d011dac18d68)",
    d: "M42.115 42.437h26.479v3.921H42.115z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayslip);
export default __webpack_public_path__ + "static/media/payslip.65465751bed26d5d84c62d8a944f2afb.svg";
export { ForwardRef as ReactComponent };